// Path: ./src/app/components/TitleToolTip/index.tsx
import React from "react";
import styled from "styled-components";

interface TooltipProps {
  text?: string;
  isVisible: boolean;
}

const StyledTooltip = styled.div`
  position: absolute;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 2px 4px;
  border-radius: 4px;
  z-index: 1000;
  font-size: 13px;
`;

export const TitleTooltip: React.FC<TooltipProps> = ({ text, isVisible }) => {
  return isVisible ? <StyledTooltip>{text}</StyledTooltip> : <></>;
};
